/** Adapted from standalone-search f83fe2d1 via selected Registrar V2. See docs/delivery/iteration2/fusion-shared-kit/TRANSFER.json. */
import * as React from "react";
import type { IconComponent } from "@/components/ui/detail-card/icon";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";
import { DetailCard } from "./DetailCard";
import { DetailCardHead } from "./DetailCardHead";

interface CollapsibleSectionProps {
  icon?: IconComponent;
  label: string;
  summary?: React.ReactNode;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "muted";
}

export function CollapsibleSection({
  icon: Icon,
  label,
  summary,
  defaultOpen,
  open,
  onOpenChange,
  children,
  className,
  variant = "default",
}: CollapsibleSectionProps) {
  const isControlled = open !== undefined;
  const [internalOpen, setInternalOpen] = React.useState(defaultOpen ?? false);
  const isOpen = isControlled ? open : internalOpen;
  const handleChange = isControlled ? onOpenChange : setInternalOpen;

  return (
    <Collapsible open={isOpen} onOpenChange={handleChange} asChild>
      <DetailCard className={cn("gap-3", className)} data-disclosure="" isOpen={isOpen}>
        <CollapsibleTrigger asChild>
          <button type="button" className="w-full rounded-control text-start outline-none focus-visible:ring-2 focus-visible:ring-ring">
            <DetailCardHead icon={Icon} title={label} hue={variant === "muted" ? "slate" : "blue"} expandable isOpen={isOpen} />
          </button>
        </CollapsibleTrigger>
        {summary && <div className="text-ui text-foreground-soft">{summary}</div>}
        {/* Disclosure is presentation: the SAME native controls stay mounted. */}
        <CollapsibleContent forceMount hidden={!isOpen} className="min-w-0 space-y-4 border-t border-rule pt-3">
          {children}
        </CollapsibleContent>
      </DetailCard>
    </Collapsible>
  );
}
